export const CardContent = ({ children, ...props }) => (
  <div className="p-4" {...props}>
    {children}
  </div>
);
